<script lang="ts" setup>
import RichTextField from '@/components/common/RichTextField.vue';
import MediaList from '@/components/media/MediaList.vue';
import { InfoGraphic } from '@/models/info-graphic.model';
import { MediaPurpose } from '@/models/media.model';
import { ref, PropType, watch } from 'vue';
import CategoriesField from '@/components/categories/CategoriesField.vue';

const props = defineProps({
  modelValue: { type: Object as PropType<InfoGraphic>, required: true },
});
const value = ref<InfoGraphic>({ ...props.modelValue });

const emit = defineEmits(['update:modelValue']);

const update = () => {
  emit('update:modelValue', value.value);
};

watch(
  () => props.modelValue,
  () => {
    Object.assign(value.value, props.modelValue);
  },
  { deep: true },
);
</script>
<template>
  <v-row>
    <v-col><h3>Infographic</h3> </v-col>
  </v-row>
  <v-row>
    <v-col>
      <v-text-field
        v-model="value.title"
        @change="update"
        label="Title"
        required
      ></v-text-field>
      <CategoriesField v-model="value.categories" @change="update" />
    </v-col>
  </v-row>
  <v-row>
    <v-col>
      <RichTextField
        label="Description"
        v-model="value.description"
        @change="update"
        :media="modelValue.media"
      />
    </v-col>
  </v-row>
  <MediaList
    v-model="value"
    @change="update"
    :required="[MediaPurpose.InfoGraphic]"
  />
</template>
